<template>
    <b-modal ref="group_modal" size="lg" bodyClass="p-0" v-bind:no-close-on-backdrop=true :hide-header=true v-model="is_show_modal" :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <b-button size="sm" variant="outline-danger" @click="close()">Close Modal</b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.item.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">

                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.item.title}}
                                <small class="text-muted mb-0">
                                    {{__t('pwa_article_news_info')}}
                                </small>
                            </h5>
                        </div>

                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :disabled="tab.disabled" :title="get_tab_title(tab)" :key="index" :active="tab.is_active">
                                    <template slot="title">
                                        {{get_tab_title(tab)}}
                                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                                    </template>

                                    <component
                                        @on_article_change="on_article_change"
                                        v-bind:is="tab.index" :item="item"></component>
                                </b-tab>
                            </b-tabs>
                        </div>
                        <div>
                        </div>
                    </div>
                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" @click="remove" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="item.id > 0">
                    {{ __t('REMOVE') }}
                </button>

                <button type="button" @click="close()" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import Info_field from "../../../../sys/info_field";
import pwa_article_info from "./tabs/pwa_article_info.vue";
import pwa_article_image from "./tabs/pwa_article_image.vue";
import pwa_article_translates from "./tabs/pwa_article_translates.vue";

export default {
    name: "article_modal",
    components : {
        Info_field,
        pwa_article_info,
        pwa_article_image,
        pwa_article_translates

    },
    props : {
        modal_position : {
            type : String,
            default : "right"
        },


    },
    data() {
        return  {
            is_show_modal : false,
            is_load_adv : false,
            is_load : false,
            item: {
                id : 0,
                title : "",
                description : "",
                state : false,
            },
            tabs:[],

        }
    },
    created() {



        EventBus.$on("news_edit", this.work_click);
        EventBus.$on("close_pwa_article",this.close);
    },

    methods : {



        async remove() {
            let self = this;
            const is_ok = confirm_me(this.__t("ARE_SURE"));

            is_ok.then(res => {
                self.is_load = true;
                api.delete('/internal/v1/catalog/pwa/news/articles/' + this.item.id).then(({data}) => {
                    self.is_load = false;
                    if (data.status === "operation_success") {
                        self.onclose();
                        EventBus.$emit("reload_categories");
                    }
                }).catch(({response}) => {
                    self.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

        async save() {
            this.is_load = true;
            let item_id = parseInt(this.item?.id ?? 0) ?? 0;

            await api.put('/internal/v1/catalog/pwa/news/articles/'+ parseInt(this.item?.id ?? 0) ?? 0,this.item).then(({data}) => {

                if (data.status === "operation_success") {
                    EventBus.$emit('save_translation',data.data.id,'pwa_article', this.Onclose);

                    if(item_id == 0) {
                        this.Onclose();
                    }
                }

            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status,
                    position : "b-toaster-top-left",
                })
            });
        },
        Onclose() {
            this.is_load = false;
            EventBus.$emit("close_pwa_article");
            EventBus.$emit("reload_news");
        },

        close() {
            this.item = {
                id : 0,
                title : "",
                description : "",
                state : true,
            };

            this.tabs = [];
            this.is_show_modal = false;

        },

        work_click(item_id) {
            this.item.id = parseInt(item_id);
            this.is_show_modal = true;
            this.load_item();
        },

        on_article_change(event) {
            if(event.hasOwnProperty("type")) {
                let atr_name = event.type;

                if(event.hasOwnProperty("value")) {
                    let atr_val = event.value;

                    if (this.item.hasOwnProperty(atr_name)) {
                        this.item[atr_name] = atr_val;
                    }
                }
            }
        },


        async load_item() {
            this.tabs = [];
            this.is_load = true;

            await api.get('/internal/v1/catalog/pwa/news/articles/' + this.item_id).then(({data}) => {
                if (data.status === "operation_success") {
                    this.item =  data.data;
                    this.is_load = false;
                    this.push_tabs();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,	position : "b-toaster-top-left"})
            });
        },

        push_tabs() {


            this.default_tabs.map(item => {
                this.tabs.push({
                    title: item.title,
                    disabled: false,
                    is_active: false,
                    is_load: false,
                    index: item.index,
                    html: ''
                });
            });
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }

            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },
    },


    computed : {

        item_id() {
            return parseInt(this.item?.id ?? 0) ?? 0;
        },

        default_tabs() {

            if(this.item_id === 0) {

                return [
                    {
                        "title": this.__t('MAIN_SETTINGS'),
                        "index": "pwa_article_info",
                        is_active:true,
                    }
                ];
            }


            return [
                {
                    "title": this.__t('MAIN_SETTINGS'),
                    "index": "pwa_article_info",
                    is_active:true,
                },

                {
                    "title": this.__t('PHOTO'),
                    "index": "pwa_article_image",
                    is_active:false,
                },

                {
                    "title": this.__t('LANGUAGES'),
                    "index": "pwa_article_translates",
                    is_active:false,
                }
            ];
        },


        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }

}
</script>

<style scoped>

</style>
